import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {

        /**
         * Handles loading office locations and updating the UI state
         * @param {HTMLElement} office - The office element that was clicked
         * @param {string} currentClass - CSS selector for the currently selected office
         * @param {string} locactionSection - Section identifier ('footer' or 'widget') 
         * @returns {void}
         */
        const loadOffices = (office, currentClass, locactionSection) => {
            
            if (!office.classList.contains('select-office-current')) {
                const currentOffice = document.querySelector(currentClass);
                if (currentOffice) {
                    currentOffice.classList.remove('select-office-current');
                }
                office.classList.add('select-office-current');
                if(locactionSection === 'footer'){
                    this.loadLocations(office);
                } else {
                    this.loadLocationsWidget(office);
                }
            }
        }

        // Offices footer
        const offices = document.querySelectorAll('.select-office');
        if (offices) {
            this.loadLocations(offices[0]);
            offices.forEach((office) => {
                office.addEventListener('click', () => loadOffices(office, '.select-office.select-office-current', 'footer'));
            });
        }

        // Offices contact page
        const offices_contact_page = document.querySelectorAll('.select-office-widget');
        if (offices_contact_page) {
            this.loadLocationsWidget(offices_contact_page[0]);
            offices_contact_page.forEach((office_contact_page) => {
                office_contact_page.addEventListener('click', () => loadOffices(office_contact_page, '.select-office-widget.select-office-current', 'widget'));
            });
        }
    },

    /**
     * Handle dropdown toggle links
     * Allows links with non-# href to function normally
     * Only prevents default behavior for # links
     */
    handleDropdownLinks() {
        // Wait for DOM to be fully loaded
        document.addEventListener('DOMContentLoaded', () => {
            
            // Get all elements with class 'nav-link dropdown-toggle'
            const dropdownToggles = document.querySelectorAll('.nav-link.dropdown-toggle');
            
            // Loop through each dropdown toggle element
            dropdownToggles.forEach((toggle, index) => {
                // Get the href attribute and remove Bootstrap dropdown behavior if it's a real URL
                if (toggle.getAttribute('href') !== '#') {
                    // Remove Bootstrap dropdown toggle attributes since this is a real link
                    toggle.removeAttribute('data-bs-toggle');
                    toggle.removeAttribute('data-bs-target');
                }
                
                // Add click event listener to each toggle
                toggle.addEventListener('click', (event) => {
                    // Get the href attribute value
                    const href = toggle.getAttribute('href');
                    
                    // Only prevent default behavior if href is "#" 
                    // This allows real URLs to work normally
                    if (href === '#') {
                        event.preventDefault();
                    }
                });
            });
        });
    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    footer_map_tablet,
                    footer_map_mobile,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong class="office-info-firm-name">${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span><br>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone"><strong class="office-info-phone">Phone: </strong>${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Get Directions</a>
                   <button class="cw-modal" data-cw-target="#hoursModal" id="office-hours">Office Hours</button>
               </div>`;

                const footerMapHTML = footer_map ? `<figure class="mb-0">
                    <a href="${directionURL}" target="_blank" aria-label="Direction Link">
                    <img class="d-none d-xl-block" src="${footer_map}" alt="${firmName}" width="380" height="439"/>
                    <img class="d-none d-md-block d-xl-none" src="${footer_map_tablet}" alt="${firmName}" width="335" height="207"/>
                    <img class="d-md-none" src="${footer_map_mobile}" alt="${firmName}" width="298" height="184"/>
                    </a>
                    </figure>` :
                    '';

                const address = `<div class="office-info-container">${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}</div>
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Load Locations Widget
     */
    async loadLocationsWidget(locationID_Widget) {
        if (locationID_Widget) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID_Widget.value}/`;
            const officeBox = document.querySelector('.office-info-single');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    footer_map_tablet,
                    footer_map_mobile,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong class="office-info-firm-name">${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span><br>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone"><strong class="office-info-phone">Phone: </strong>${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Get Directions</a>
                   <button class="cw-modal" data-cw-target="#hoursModal" id="office-hours">Office Hours</button>
               </div>`;

                const footerMapHTML = footer_map ? `<figure class="mb-0">
                    <a href="${directionURL}" target="_blank" aria-label="Direction Link">
                    <img class="d-none d-md-block " src="${footer_map_tablet}" alt="${firmName}" width="335" height="207"/>
                    <img class="d-md-none" src="${footer_map_mobile}" alt="${firmName}" width="298" height="184"/>
                    </a>
                    </figure>` :
                    '';

                const address = `<div class="office-info-container">${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}</div>
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;